import React, { useMemo } from "react";
import { IGame } from "@/redux/games/types";
import { GamesItem } from "../GamesItem";
import { filterPastGames } from "@/utils/games/gameHelpers";
import { groupByDate } from "@/utils/date/dateGrouping";
import { DateSection } from "@/components/DateSection";
import { useAppSelector } from "@/redux/store";
import { getProfileInfo } from "@/redux/profile/settings/getProfileInfo/selectors";
import { selectGamesLoading } from "@/redux/games";
import styles from "./AvailableGamesScreen.module.scss";
import { EmptyGameList } from "../EmptyGameList/EmptyGameList";
import { GameSkeleton } from "../GameSkeleton";

interface AvailableGamesScreenProps {
  listGames: IGame[];
  setIsRequiredAuthOpened: (value: boolean) => void;
}

export const AvailableGamesScreen: React.FC<AvailableGamesScreenProps> = ({
  listGames,
  setIsRequiredAuthOpened,
}) => {
  const profileInfo = useAppSelector(getProfileInfo);
  const currentUserId = profileInfo.profileInfo?.id;
  const isLoading = useAppSelector(selectGamesLoading);

  const activeGames = useMemo(() => filterPastGames(listGames), [listGames]);
  const dateGroups = useMemo(() => groupByDate(activeGames), [activeGames]);

  if (isLoading) {
    return (
      <div className={styles.skeletonList}>
        {[...Array(6)].map((_, index) => (
          <GameSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (activeGames.length === 0) {
    return (
      <EmptyGameList
        title="Ой, список ваших игр пуст!"
        description="Нет игр на ближайшее время. Вы можете создать свою игру в разделе «Мои игры», в подразделе «Вы создатель»"
        showButton={false}
      />
    );
  }

  return (
    <div className={styles.list}>
      {dateGroups.map((group) => (
        <DateSection key={group.dateLabel} dateLabel={group.dateLabel}>
          {group.items.map((game) => {
            const isCreatedByUser = Boolean(
              currentUserId && game.creator_id === currentUserId
            );

            return (
              <GamesItem
                key={game.id}
                item={game}
                isCreateGame={isCreatedByUser}
                setIsRequiredAuthOpened={setIsRequiredAuthOpened}
              />
            );
          })}
        </DateSection>
      ))}
    </div>
  );
};
